var _module_exports = "<div class=\"fancy-menu-details-title\">Square root</div>\n<p>\n  Calculates a positive square root.\n</p>\n";;
var path = '/builds/observability/imm/signalview/src/legacy/app/analytics/block/SQRT/description.tpl.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;